import { ReactElement } from 'react';

import { button } from './iconButton.css';

export interface IconButtonProps {
  /** The label for the button. */
  label: string;
  /** Callback for when the user clicks the button. */
  onClick: () => void;
  /** The icon to display in the button. */
  icon: ReactElement;
}

export function IconButton({ label, onClick, icon }: IconButtonProps) {
  return (
    <button className={button} onClick={onClick} aria-label={label} type="button">
      {icon}
    </button>
  );
}
